import { render, staticRenderFns } from "./SwedbankBankLinkPaymentInfo.vue?vue&type=template&id=59aac9af"
import script from "./SwedbankBankLinkPaymentInfo.vue?vue&type=script&lang=ts"
export * from "./SwedbankBankLinkPaymentInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports